const types = {

    POST_COMMENT: "POST_COMMENT",
    POST_COMMENT_RESP: "POST_COMMENT_RESP",
    POST_COMMENT_CLEAR: "POST_COMMENT_CLEAR",

    POST_DISLIKE_LIKE_COMMENT: "POST_DISLIKE_LIKE_COMMENT",
    POST_DISLIKE_LIKE_COMMENT_RESP: "POST_DISLIKE_LIKE_COMMENT_RESP",
    POST_DISLIKE_LIKE_COMMENT_CLEAR: "POST_DISLIKE_LIKE_COMMENT_CLEAR",

    FETCH_COMMENT: "FETCH_COMMENT",
    FETCH_COMMENT_RESP: "FETCH_COMMENT_RESP",
    FETCH_COMMENT_CLEAR: "FETCH_COMMENT_CLEAR",

    LIKE_DISLIKE_PRODUCT: "LIKE_DISLIKE_PRODUCT",
    LIKE_DISLIKE_PRODUCT_RESP: "LIKE_DISLIKE_PRODUCT_RESP",
    LIKE_DISLIKE_PRODUCT_CLEAR: "LIKE_DISLIKE_PRODUCT_CLEAR",
}

export default types;